export const treepins = [
  /*{
    name: 'Floating clouds maple',
    coor: [34.7071568, -86.6321067],
    code: [1, 4, 3, 2],
  },*/
  {
    name: 'Spanish Oak',
    coor: [34.708008, -86.634358],
    code: ['1', '3', '2', '8'],
    image:
      'https://images.unsplash.com/photo-1572526159456-2e032b4def60?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8b2FrfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60',
    class: ['Simple', 'Tipped', 'Alternate', 'Bell'],
    description:
      'Quercus falcata,  also called southern red oak, spanish oak, bottomland red oak or three-lobed red oak is an oak (part of the genus Quercus). Native to the southeastern United States, it gets its name the "Spanish Oak" as these are the areas of early Spanish colonies, whilst "southern red oak" comes from both its range and leaf color during late summer and fall.The southern red oak is a deciduous angiosperm, so has leaves that die after each growing period and come back in the next period of growth',
  },
  {
    name: 'Winged elm',
    coor: [34.706788, -86.634162],
    code: ['4', '4', '5', '8'],
    image: 'https://www.carolinanature.com/trees/ulal1140981.jpg',
    class: ['Simple', 'Edge Double Serrate', 'Alternate', 'Oblong'],
    description:
      'Ulmus alata, the winged elm or wahoo, is a small- to medium-sized deciduous tree endemic to the woodlands of the southeastern and south-central United States. The species is tolerant of a wide range of soils, and of ponding, but is the least shade-tolerant of the North American elms. Its growth rate is often very slow, the trunk increasing in diameter by less than 5 mm (3⁄16 in) per year. The tree is occasionally considered a nuisance as it readily invades old fields, forest clearings, and rangelands, proving particularly difficult to eradicate with herbicides.',
  },
  {
    name: 'September elm',
    coor: [34.707107, -86.634231],
    code: ['8', '9', '7', '2'],
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Ulmus_serotina_20100627.jpg/330px-Ulmus_serotina_20100627.jpg',
    class: ['Simple', 'Edge Double Serrate', 'Alternate', 'Oblong'],

    description:
      'Ulmus serotina Sarg., the September elm, is an autumn-flowering North American species of tree. It is uncommon beyond Tennessee; only very locally distributed through Illinois, Kentucky, Arkansas, Mississippi, Oklahoma, Alabama and Georgia, and disjunct into Nuevo León, Mexico. It grows predominantly on limestone bluffs and along streams to elevations of 400 m.',
  },
  {
    name: 'Red cedar',
    coor: [34.707261, -86.634346],
    code: ['5', '6', '2', '1'],
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/2014-05-13_08_32_55_Eastern_Red_Cedar_at_South_Riding_Golf_Club_in_South_Riding%2C_Virginia.JPG/330px-2014-05-13_08_32_55_Eastern_Red_Cedar_at_South_Riding_Golf_Club_in_South_Riding%2C_Virginia.JPG',
    class: ['Simple', 'Smooth', 'Whorled', 'Scale'],
    description:
      'Juniperus virginiana, known as red cedar, eastern redcedar, Virginian juniper, eastern juniper, red juniper, pencil cedar, and aromatic cedar, is a species of juniper native to eastern North America from southeastern Canada to the Gulf of Mexico and east of the Great Plains.',
  },
  { name: 'Scarlet oak', coor: [34.707666, -86.634285] },
  { name: 'Southern red oak', coor: [34.707714, -86.634333] },
  { name: 'Old field pine', coor: [34.707951, -86.634298] },
];
